import { CacheStrategy, DataSourceStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { STORAGE_ADDRESS_PATTERN } from '../types/storage-address-pattern.js';
import { StorageAddressKindValues, STORAGE_ADDRESS_KIND_LABELS } from '../types/storage-address.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for StorageAddressPattern (0168).
 * Stored in 'org/{orgId}/storage-address-pattern'.
 */
export const storageAddressPatternDescriptor = {
    name: STORAGE_ADDRESS_PATTERN,
    label: 'Padrão de endereço',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/storage-address-pattern',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 2,
    description: 'Named components + mask that assemble a storage-address scan code',
    repositoryConfig: {
        dataSource: DataSourceStrategy.PostgresRest,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: [DataSourceStrategy.PostgresRest],
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
        },
        {
            name: 'code',
            label: 'Código',
            type: 'number',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric pattern code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'name',
            label: 'Nome',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
        },
        {
            name: 'components',
            label: 'Componentes',
            type: 'object',
            required: true,
            description: 'StorageAddressPatternComponent[] — ordered named slots',
        },
        {
            name: 'mask',
            label: 'Máscara',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.STORAGE_ADDRESS_MASK,
            description: 'Assembly template with {key} tokens, e.g. R{rua}-P{predio}',
        },
        {
            name: 'defaultKind',
            label: 'Tipo sugerido',
            type: 'enum',
            required: false,
            enumValues: [...StorageAddressKindValues],
            enumLabels: STORAGE_ADDRESS_KIND_LABELS,
        },
        {
            name: 'defaultCapacity',
            label: 'Capacidade sugerida',
            type: 'number',
            required: false,
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [...AUDIT_FOREIGN_KEYS],
};
//# sourceMappingURL=storage-address-pattern.descriptor.js.map